// extracted by mini-css-extract-plugin
module.exports = {"span1":"LinearLoader_span1__Dkdms","animation1":"LinearLoader_animation1__3Q7_i","span2":"LinearLoader_span2__1ZyQo","animation2":"LinearLoader_animation2__2beoz"};